// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { InterceptionOverrideSchema } from './InterceptionOverrideSchema'
import type { InterceptionOverride } from './InterceptionOverrideSchema'
import { HttpInterceptionRuleSchema } from './HttpInterceptionRuleSchema';

/////////////////////////////////////////
// HTTP INTERCEPTION RULE RELATION SCHEMA
/////////////////////////////////////////

export type HttpInterceptionRuleRelations = {
  overrides: InterceptionOverride[];
};

export type HttpInterceptionRuleWithRelations = z.infer<typeof HttpInterceptionRuleSchema> & HttpInterceptionRuleRelations

export const HttpInterceptionRuleWithRelationsSchema: z.ZodType<HttpInterceptionRuleWithRelations> = HttpInterceptionRuleSchema.merge(z.object({
  overrides: z.lazy(() => InterceptionOverrideSchema).array(),
}))